export const ForgotPassword = {
    Title: 'Forgot password',
    SubHeaders: {
        LoginConfirmed: 'Email has been sent to you. Please enter verification code and new password',
        LoginIsNotConfirmedYet: 'Enter your email address and we will send you a temporary password.'
    },
    Inputs: {
        Email: {
            placeholder: 'Enter your email address',
            label: 'LOGIN'
        },
        VerificationCode: {
            placeholder: 'Enter the code from email'
        },
        Password: {
            placehoder: 'Enter your new password'
        },
        PasswordConfirmation: {
            placehoder: 'Enter your new password again'
        }
    },
    Buttons: {
        Confirm: {
            label: 'Confirm'
        },
        SendPassword: {
            label: 'Send Temporary Password'
        }
    },
    PasswordChecker: {
        Header: 'Password Requirement'
    },
    Errors: {
        Messages: {
            Email: 'Email is incorrect',
            VerificationCode: 'Verification code can\'t be empty',
            PasswordConfirm: 'The passwords do not match.',
            OldVerificationCode: 'Invalid or old verification code provided. Please verify that you are entering the verification code from the most recent email that you received.'
        }
    },
    Codes: {
        verificationCodeMismatch: 'CodeMismatchException',
        verificationCodeExpired: 'ExpiredCodeException'
    }
}



// WEBPACK FOOTER //
// ./src/localization/ForgotPassword.ts